import { useContext } from "react";
import ApplicationContext from "./ApplicationContext";

const useApplicationProvider = () => {
    const { onAppSelected } = useContext(ApplicationContext);
    return { onAppSelected }
}

export default useApplicationProvider;